import React from 'react';
import { BrowserRouter as Router } from "react-router-dom";
import Navbar from './components/Navbar';
import Header from './components/Header';
import About from './components/About';
import Portfolio from './components/Portfolio';
import Resume from './components/Resume';
import Contact from './components/Contact';
import Footer from './components/Footer';
import Wrapper from './components/Wrapper';
import portfolio from './portfolio.json';

function App() {
  return (
    <Router>
      <div>
        <Navbar />
        <Header />
        <About />
        <Resume />
        <Wrapper>
          <h4 className="title">CHECK OUT SOME OF MY WORK</h4>
          <div className="container" id="portfolio">
            <div className="row">
              {portfolio.map(portfolios => (<Portfolio key={portfolios.id} {...portfolios} />))}
            </div>
          </div>
        </Wrapper>
        <Contact />
        <Footer />
      </div>
    </Router>
  );
}

export default App;
